export default "__VITE_ASSET__BkI39WVl__"